import { SHOW_PIN_FORM, HIDE_PIN_FORM } from '../actions/constants';

const initialState = {
  show: false,
  title: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_PIN_FORM:
      return {
        show: true,
        ...action.params,
      };
    case HIDE_PIN_FORM:
      return {
        show: false,
        title: '',
      };
    default:
      return state;
  }
};
